(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BUNDLE-bANNER"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-ig-any4-scroll]');
  if (!link) return;

  const target = document.getElementById('build-your-bundle');
  if (!target) return;

  event.preventDefault();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  target.focus({ preventScroll: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Bundle-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const SLOT_COUNT = 4;
    const selections = new Array(SLOT_COUNT).fill(null);
    const storageKey = `ig-any4:${root.dataset.sectionId}`;
    const desktop = window.matchMedia('(min-width: 990px)');

    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => Array.from(root.querySelectorAll(selector));

    const slots = $$('[data-slot]');
    const box = $('[data-box]');
    const boxBody = $('[data-box-body]');
    const boxToggle = $('[data-box-toggle]');
    const boxClose = $('[data-box-close]');
    const backdrop = $('[data-box-backdrop]');
    const barThumbs = $$('[data-bar-thumbs] span');
    const progressCount = $('[data-progress-count]');
    const progressText = $('[data-progress-text]');
    const meter = $('[data-meter]');
    const valueLine = $('[data-value]');
    const bundleButtons = $$('[data-add-bundle]');
    const primaryButton = $('[data-add-bundle][data-parent-variant-id]');
    const bundleButtonLabel = primaryButton ? primaryButton.textContent.trim() : 'Add bundle to cart';
    const parentVariantId = Number(primaryButton?.dataset.parentVariantId || 0);
    const errorBox = $('[data-error]');
    const completeBox = $('[data-complete]');
    const checkoutNow = $('[data-checkout-now]');
    const barStatus = $('[data-bar-status]');
    const grid = $('[data-grid]');
    const head = $('.pa4__head');
    const search = $('[data-search]');
    const sort = $('[data-sort]');
    const empty = $('[data-empty]');
    const results = $('[data-results]');
    const loading = $('[data-products-loading]');
    const announcer = $('[data-announcer]');
    const chips = $$('[data-filter]');
    const tiles = $$('[data-ig-any4-filter]');
    const sectionId = root.dataset.sectionId;
    const bundlePrice = Number(root.dataset.bundlePrice || 0);
    const bundleType = (root.dataset.bundleType || '').trim();
    const moneyFormat = root.dataset.moneyFormat || '';

    let cards = [];
    let activeFilter = 'all';
    let isLoadingProducts = false;
    let isSubmitting = false;

    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const escapeHtml = (value) => {
      const div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    };

    const formatMoney = (cents) => {
      const value = (Number(cents) || 0) / 100;
      const withSeparators = (decimals, thousands, decimal) => {
        const [whole, fraction] = value.toFixed(decimals).split('.');
        const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return fraction ? `${grouped}${decimal}${fraction}` : grouped;
      };
      if (!moneyFormat) return `$${withSeparators(2, ',', '.')}`.replace(/\.00$/, '');
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
        switch (key) {
          case 'amount_no_decimals': return withSeparators(0, ',', '.');
          case 'amount_with_comma_separator': return withSeparators(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withSeparators(0, '.', ',');
          case 'amount_with_apostrophe_separator': return withSeparators(2, "'", '.');
          default: return withSeparators(2, ',', '.');
        }
      }).replace(/\.00(?!\d)/, '');
    };

    const announce = (message) => {
      if (!announcer) return;
      announcer.textContent = '';
      window.setTimeout(() => { announcer.textContent = message; }, 50);
    };

    const flashBox = () => {
      if (!box) return;
      box.classList.remove('is-flash');
      void box.offsetWidth;
      box.classList.add('is-flash');
    };

    const save = () => {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(selections.map((item) => item?.variantId || null)));
      } catch (error) { /* storage unavailable: picks just won't survive a reload */ }
    };

    const addLabelHtml = (title) => `Add to box<span class="ig-any4__sr">: ${escapeHtml(title)}</span>`;
    const addedLabelHtml = (title) =>
      `<span aria-hidden="true">✓</span> In your box<span class="ig-any4__sr">: ${escapeHtml(title)}. Select to remove</span>`;

    const count = () => selections.filter(Boolean).length;

    /* ---------- Bottom sheet (tablet and mobile) ---------- */

    const setBoxOpen = (open, { returnFocus = true } = {}) => {
      if (desktop.matches) open = false;
      root.classList.toggle('is-box-open', open);
      // Shopify Inbox's chat bubble sits over the sheet's buttons; hide it only while the sheet is open.
      document.documentElement.classList.toggle('ig-any4-sheet-open', open);
      if (backdrop) backdrop.hidden = !open;
      boxToggle?.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        // Wait until the sheet is visible before moving focus into it.
        window.setTimeout(() => boxClose?.focus({ preventScroll: true }), 50);
      } else if (returnFocus && document.activeElement && boxBody?.contains(document.activeElement)) {
        boxToggle?.focus({ preventScroll: true });
      }
    };

    boxToggle?.addEventListener('click', () => setBoxOpen(!root.classList.contains('is-box-open')));
    boxClose?.addEventListener('click', () => setBoxOpen(false));
    backdrop?.addEventListener('click', () => setBoxOpen(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-box-open')) {
        setBoxOpen(false, { returnFocus: false });
        boxToggle?.focus({ preventScroll: true });
      }
    });
    desktop.addEventListener?.('change', () => setBoxOpen(false, { returnFocus: false }));

    /* ---------- Rendering ---------- */

    const render = () => {
      const selected = count();
      const remaining = SLOT_COUNT - selected;
      const isFull = selected === SLOT_COUNT;
      const picksValue = selections.reduce((sum, item) => sum + (item ? item.price : 0), 0);

      root.classList.toggle('has-items', selected > 0);
      root.classList.toggle('is-complete', isFull);
      if (progressCount) progressCount.textContent = selected;
      if (completeBox) completeBox.hidden = !isFull;
      if (checkoutNow) checkoutNow.hidden = !isFull;
      if (barStatus) {
        barStatus.innerHTML = isFull
          ? '✓ Bundle complete'
          : `Your box <strong><span data-bar-count>${selected}</span>/${SLOT_COUNT}</strong>`;
      }

      if (meter) {
        meter.setAttribute('aria-valuenow', selected);
        meter.setAttribute('aria-valuetext', `${selected} of ${SLOT_COUNT} pieces added`);
        meter.querySelectorAll('span').forEach((bar, index) => bar.classList.toggle('is-on', index < selected));
      }

      if (progressText) {
        progressText.hidden = isFull;
        progressText.textContent = selected === 0
          ? `Add ${SLOT_COUNT} pieces to fill your box`
          : `Add ${remaining} more ${remaining === 1 ? 'piece' : 'pieces'} to unlock Add To Cart`;
      }

      // Only claim value when it is true: the picks are worth more than the bundle price.
      const showValue = bundlePrice > 0 && picksValue > bundlePrice;
      if (valueLine) {
        valueLine.hidden = !showValue;
        if (showValue) {
          valueLine.innerHTML = isFull
            ? `Worth <s>${formatMoney(picksValue)}</s>, yours for ${formatMoney(bundlePrice)}. <em>You save ${formatMoney(picksValue - bundlePrice)}.</em>`
            : `Worth <s>${formatMoney(picksValue)}</s> so far. Your box is ${formatMoney(bundlePrice)}.`;
        }
      }

      // Add To Cart stays visible; until the box is full it explains what's missing instead of doing nothing.
      bundleButtons.forEach((button) => {
        if (!isSubmitting) button.disabled = !parentVariantId;
        button.setAttribute('aria-disabled', isFull ? 'false' : 'true');
      });

      slots.forEach((slot, index) => {
        const item = selections[index];
        const emptyButton = slot.querySelector('.pa4__slot-empty');
        const filled = slot.querySelector('.pa4__slot-item');
        slot.classList.toggle('is-filled', Boolean(item));
        if (emptyButton) emptyButton.hidden = Boolean(item);
        if (!filled) return;
        filled.hidden = !item;
        if (!item) return;
        const img = filled.querySelector('img');
        if (img) {
          img.hidden = !item.image;
          if (item.image) img.src = item.image;
          img.alt = item.label;
        }
        filled.title = item.label;
        filled.querySelector('.pa4__slot-name').textContent = item.label;
        filled.querySelector('[data-remove-name]').textContent = item.label;
      });

      barThumbs.forEach((thumb, index) => {
        const item = selections[index];
        thumb.classList.toggle('is-filled', Boolean(item));
        thumb.style.backgroundImage = item?.image ? `url("${item.image}")` : '';
      });

      cards.forEach((card) => {
        const button = card.querySelector('[data-add-item]');
        if (!button || button.disabled) return;
        if (isFull && !card.classList.contains('is-selected')) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
      });
    };

    /* ---------- Filtering and sorting ---------- */

    const indexCards = () => {
      cards = $$('[data-product-card]');
      cards.forEach((card, index) => {
        if (card.dataset.index === undefined) card.dataset.index = index;
      });
    };

    const updateCounts = () => {
      chips.map((chip) => chip.dataset.filter).filter((key) => key && key !== 'all').forEach((key) => {
        const total = cards.filter((card) => card.dataset.category === key).length;
        root.querySelectorAll(`[data-tile-count="${key}"]`).forEach((el) => { el.textContent = total; });
        chips.filter((chip) => chip.dataset.filter === key).forEach((chip) => { chip.hidden = total === 0; });
      });
    };

    const applyFilters = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visible = 0;

      cards.forEach((card) => {
        const show =
          (activeFilter === 'all' || card.dataset.category === activeFilter) &&
          (!query || (card.dataset.title || '').includes(query));
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0 || isLoadingProducts;
      if (results) results.textContent = isLoadingProducts ? '' : `${visible} ${visible === 1 ? 'piece' : 'pieces'}`;
    };

    const applySort = () => {
      if (!grid) return;
      const mode = sort?.value || 'default';
      const soldOutLast = (card) => (card.dataset.available === 'true' ? 0 : 1);

      const sorted = [...cards].sort((a, b) => {
        if (mode === 'az') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        if (mode === 'za') return (b.dataset.title || '').localeCompare(a.dataset.title || '');
        if (mode === 'low') return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
        if (mode === 'high') return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
        // Featured: collection order with sold-out pieces last.
        return soldOutLast(a) - soldOutLast(b) || Number(a.dataset.index) - Number(b.dataset.index);
      });

      sorted.forEach((card) => grid.appendChild(card));
      applyFilters();
    };

    const setFilter = (filter) => {
      activeFilter = filter;
      chips.forEach((chip) => {
        const isActive = chip.dataset.filter === filter;
        chip.classList.toggle('is-active', isActive);
        chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      tiles.forEach((tile) => tile.setAttribute('aria-pressed', tile.dataset.igAny4Filter === filter ? 'true' : 'false'));
      applyFilters();
    };

    const scrollToProducts = () => {
      const target = head || grid;
      if (!target) return;
      const offset = parseFloat(getComputedStyle(root).getPropertyValue('--ig-any4-offset')) || 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset - 8;
      window.scrollTo({ top, behavior: reduceMotion() ? 'auto' : 'smooth' });
    };

    /* ---------- Selecting pieces ---------- */

    const variantInputFor = (card) =>
      card.querySelector('input[type="radio"][data-variant-select]:checked') ||
      (() => {
        const control = card.querySelector('select[data-variant-select], input[type="hidden"][data-variant-select]');
        if (!control) return null;
        return control.tagName === 'SELECT' ? control.options[control.selectedIndex] : control;
      })();

    const lockOptions = (card, locked) => {
      card.querySelectorAll('[data-variant-group], select[data-variant-select]').forEach((el) => { el.disabled = locked; });
    };

    const select = (card, { silent = false } = {}) => {
      const button = card.querySelector('[data-add-item]');
      if (!button || button.disabled || card.classList.contains('is-selected')) return false;

      const emptyIndex = selections.findIndex((item) => item === null);
      if (emptyIndex === -1) {
        if (!silent) {
          announce('Your box is full. Remove a piece to swap it for this one.');
          flashBox();
        }
        return false;
      }

      const option = variantInputFor(card);
      if (!option || option.dataset.available !== 'true') return false;

      const productTitle = button.dataset.productTitle || '';
      const variantTitle = option.dataset.variantTitle || '';
      const label = variantTitle && variantTitle !== 'Default Title' ? `${productTitle} — ${variantTitle}` : productTitle;

      selections[emptyIndex] = {
        variantId: option.value,
        productTitle,
        variantTitle,
        label,
        price: Number(option.dataset.price || card.dataset.price || 0),
        image: button.dataset.image || '',
        card
      };

      card.classList.add('is-selected');
      button.classList.add('is-added');
      button.innerHTML = addedLabelHtml(productTitle);
      lockOptions(card, true);

      render();
      save();
      if (!silent) {
        if (count() === SLOT_COUNT) {
          announce(`Added ${label}. Your bundle is complete. Add it to your cart or check out now.`);
          flashBox();
          // On mobile, bring up the box so the next step (Add To Cart / Checkout) is right there.
          setBoxOpen(true);
        } else {
          announce(`Added ${label}. ${count()} of ${SLOT_COUNT} in your box.`);
        }
      }
      return true;
    };

    const clearSlot = (index) => {
      const item = selections[index];
      if (!item) return null;
      const { card } = item;
      const button = card?.querySelector('[data-add-item]');
      card?.classList.remove('is-selected');
      if (button) {
        button.classList.remove('is-added');
        button.innerHTML = addLabelHtml(item.productTitle);
      }
      if (card) lockOptions(card, false);
      selections[index] = null;
      return item;
    };

    const unselect = (index) => {
      const item = clearSlot(index);
      if (!item) return;
      render();
      save();
      announce(`Removed ${item.label}. ${count()} of ${SLOT_COUNT} in your box.`);
    };

    const restore = () => {
      let saved;
      try {
        saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      } catch (error) {
        return;
      }
      if (!Array.isArray(saved)) return;

      saved.forEach((variantId) => {
        const id = variantId ? String(variantId) : '';
        if (!id || selections.some((item) => item?.variantId === id)) return;

        const card = cards.find((candidate) => {
          const radio = Array.from(candidate.querySelectorAll('input[type="radio"][data-variant-select]')).find((input) => input.value === id);
          if (radio) {
            if (radio.disabled) return false;
            radio.checked = true;
            return true;
          }
          const control = candidate.querySelector('select[data-variant-select], input[type="hidden"][data-variant-select]');
          if (!control) return false;
          if (control.tagName !== 'SELECT') return control.value === id;
          const option = Array.from(control.options).find((opt) => opt.value === id && !opt.disabled);
          if (option) control.value = option.value;
          return Boolean(option);
        });
        if (card) select(card, { silent: true });
      });
    };

    /*
     * Load every remaining collection page. Liquid renders up to 250 products per request,
     * so further pages come from the Section Rendering API and are appended to this grid.
     */
    const loadAllProducts = async () => {
      let nextLink = $('[data-next-page]');
      if (!grid || !sectionId || !nextLink) return;

      isLoadingProducts = true;
      if (loading) loading.hidden = false;
      if (empty) empty.hidden = true;

      try {
        let safety = 0;
        while (nextLink && safety < 1000) {
          safety += 1;
          const requestUrl = new URL(nextLink.getAttribute('href'), window.location.origin);
          requestUrl.searchParams.set('section_id', sectionId);

          const response = await fetch(requestUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`Unable to load products page ${safety + 1}.`);

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incomingRoot = doc.querySelector('.pa4');
          const incomingGrid = incomingRoot?.querySelector('[data-grid]');
          if (!incomingGrid) break;

          incomingGrid.querySelectorAll('[data-product-card]').forEach((card) => grid.appendChild(card));
          indexCards();

          const incomingNext = incomingRoot.querySelector('[data-next-page]');
          const currentNext = $('[data-next-page]');
          if (incomingNext && currentNext) {
            currentNext.setAttribute('href', incomingNext.getAttribute('href'));
            nextLink = currentNext;
          } else {
            currentNext?.remove();
            nextLink = null;
          }
        }
      } catch (error) {
        console.error('[Pick Any 4] Product auto-load error:', error);
      } finally {
        isLoadingProducts = false;
        if (loading) loading.hidden = true;
        indexCards();
      }
    };

    /* ---------- Sticky offset under Impulse's header ---------- */

    const siteHeader = document.getElementById('SiteHeader');
    let offsetFrame = null;
    const updateOffset = () => {
      offsetFrame = null;
      const bottom = siteHeader ? Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom)) : 0;
      root.style.setProperty('--ig-any4-offset', `${bottom}px`);
    };
    const queueOffset = () => {
      if (offsetFrame === null) offsetFrame = window.requestAnimationFrame(updateOffset);
    };
    window.addEventListener('scroll', queueOffset, { passive: true });
    window.addEventListener('resize', queueOffset);
    updateOffset();

    /* ---------- Events ---------- */

    root.addEventListener('click', (event) => {
      const tile = event.target.closest('[data-ig-any4-filter]');
      if (tile) {
        const filter = tile.dataset.igAny4Filter;
        setFilter(activeFilter === filter ? 'all' : filter);
        scrollToProducts();
        return;
      }

      if (event.target.closest('[data-scroll-products]')) {
        event.preventDefault();
        setBoxOpen(false);
        scrollToProducts();
        root.querySelector('[data-filter].is-active')?.focus({ preventScroll: true });
        return;
      }

      const removeButton = event.target.closest('[data-remove-slot]');
      if (removeButton) {
        const index = Number(removeButton.dataset.removeSlot) - 1;
        unselect(index);
        slots[index]?.querySelector('.pa4__slot-empty')?.focus();
        return;
      }

      const addButton = event.target.closest('[data-add-item]');
      if (addButton) {
        event.preventDefault();
        const card = addButton.closest('[data-product-card]');
        if (!card) return;
        if (card.classList.contains('is-selected')) {
          unselect(selections.findIndex((item) => item?.card === card));
        } else {
          select(card);
        }
      }
    });

    chips.forEach((chip) => chip.addEventListener('click', () => setFilter(chip.dataset.filter)));
    search?.addEventListener('input', applyFilters);
    sort?.addEventListener('change', applySort);

    /* ---------- Add the bundle to cart (cart contract unchanged) ---------- */

    const handleAddBundle = async ({ goToCheckout = false } = {}) => {
      if (isSubmitting) return;

      const remaining = selections.filter((item) => !item).length;
      if (remaining > 0) {
        announce(`Add ${remaining} more ${remaining === 1 ? 'piece' : 'pieces'} to unlock Add To Cart.`);
        flashBox();
        if (!desktop.matches) {
          setBoxOpen(false, { returnFocus: false });
          scrollToProducts();
        }
        return;
      }

      if (!parentVariantId) {
        if (errorBox) {
          errorBox.textContent = 'Please select the parent bundle product in the theme editor.';
          errorBox.hidden = false;
        }
        setBoxOpen(true);
        return;
      }

      isSubmitting = true;
      bundleButtons.forEach((button) => {
        button.disabled = true;
        button.textContent = 'Adding…';
      });
      if (checkoutNow) checkoutNow.disabled = true;
      if (errorBox) errorBox.hidden = true;

      const bundleId = `bundle-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      const properties = { _bundle_id: bundleId };
      // Hidden note for packing/reporting (e.g. "Men"). Flow only reads *_variant_id keys, so it ignores this.
      if (bundleType) properties._bundle_type = bundleType;

      selections.forEach((item, index) => {
        const visibleName =
          item.variantTitle && item.variantTitle !== 'Default Title'
            ? `${item.productTitle} — ${item.variantTitle}`
            : item.productTitle;

        properties[`Selection ${index + 1}`] = visibleName;
        properties[`_selection_${index + 1}_variant_id`] = item.variantId;
      });

      const rootPath = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parentVariantId, quantity: 1, properties }] })
        });

        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.description || body.message || 'Unable to add bundle to cart.');
        }

        const addedData = await response.json().catch(() => null);

        // Impulse cart hooks.
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: addedData } }));

        // The bundle is in the cart: empty the box so a second bundle starts fresh.
        isSubmitting = false;
        if (checkoutNow) checkoutNow.disabled = false;
        for (let index = 0; index < SLOT_COUNT; index += 1) clearSlot(index);
        bundleButtons.forEach((button) => { button.textContent = bundleButtonLabel; });
        setBoxOpen(false, { returnFocus: false });
        render();
        save();
        announce('Bundle added to cart.');

        if (goToCheckout) {
          window.location.href = `${rootPath}checkout`;
          return;
        }

        // Open the Impulse cart drawer.
        window.setTimeout(() => {
          const drawerTrigger =
            document.querySelector('.js-drawer-open-cart') ||
            document.querySelector('[aria-controls="CartDrawer"]') ||
            document.querySelector('[data-cart-drawer-trigger]');

          if (drawerTrigger) {
            drawerTrigger.click();
          } else {
            window.location.href = `${rootPath}cart`;
          }
        }, 250);
      } catch (error) {
        isSubmitting = false;
        if (checkoutNow) checkoutNow.disabled = false;
        if (errorBox) {
          errorBox.textContent = error.message || 'Unable to add bundle to cart.';
          errorBox.hidden = false;
        }
        bundleButtons.forEach((button) => { button.textContent = bundleButtonLabel; });
        render();
        setBoxOpen(true);
      }
    };

    bundleButtons.forEach((button) => button.addEventListener('click', () => handleAddBundle()));
    checkoutNow?.addEventListener('click', () => handleAddBundle({ goToCheckout: true }));

    /* ---------- Start ---------- */

    indexCards();
    updateCounts();
    applySort();
    render();

    // Restore once every product is on the page, so saved picks from later pages aren't dropped.
    loadAllProducts().then(() => {
      updateCounts();
      applySort();
      restore();
      render();
    });
  };

  const start = () => document.querySelectorAll('.ig-any4.pa4').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('.ig-any4.pa4').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
